module.exports = __webpack_public_path__ + "static/media/cz.4b9bac34.svg";